<template>
    <div>
      <domain-opposition-list></domain-opposition-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  